var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSelectCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 168,
    height: 94,
    viewBox: "0 0 168 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 18.5,
    width: 140,
    height: 41,
    rx: 4.5,
    fill: "#F1F5FA",
    stroke: "#CCD2E0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M126.875 52.875L140.72 86.1079L145.636 71.6358L160.108 66.7204L126.875 52.875Z",
    fill: "white",
    stroke: "#5D6A86",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M146.458 72.4583L158.208 84.2083",
    stroke: "#5D6A86",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M153.164 8L143.998 15.745",
    stroke: "#5D6A86",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M160 27H148",
    stroke: "#5D6A86",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M131 1L131 13",
    stroke: "#5D6A86",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectCard);
export default __webpack_public_path__ + "static/media/selectCard.dd2d4fa731978601fe328942efc323fd.svg";
export { ForwardRef as ReactComponent };